import { TitleCardStyled, TitleStyled } from './form-stepper-header.styled';
import Jpaper from '@atoms/JPaper';
import { useTranslation } from 'react-i18next';

interface Props {
  titles: string[];
  stepIndex: number;
  clickable: boolean;
  onChangeStep: (index: number) => void;
}
const FormStepperHeader = ({
  titles,
  stepIndex,
  onChangeStep,
  clickable,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Jpaper direction="row" alignItems="center" justifyContent="space-between">
      {titles.map((item, index) => {
        const filled = index < stepIndex;
        const active = stepIndex === index;

        return (
          <TitleCardStyled
            attrs={{ clickable, filled, active }}
            onClick={clickable ? () => onChangeStep(index) : undefined}
            key={item}
          >
            <span>{index + 1}.</span>
            <TitleStyled attrs={{ filled, active }} key={item}>
              {t(item)}
            </TitleStyled>
          </TitleCardStyled>
        );
      })}
    </Jpaper>
  );
};

export default FormStepperHeader;
